// extracted by mini-css-extract-plugin
module.exports = {"list":"bookings_list__1kJCX","item":"bookings_item__1nTDv","details":"bookings_details__1AzCF","type":"bookings_type__Khn5D","editor":"bookings_editor__1g0s1"};